import driversApi from './DriversApi';
import searchApi from './SearchApi';
import usersApi from './UsersApi';
import tripsApi from './TripsApi';
import tagsApi from './TagsApi';
import locationsApi from './LocationsApi';
import fleetApi from './FleetApi';
import promotionsApi from './PromotionsApi';
import tripThrottlingApi from './TripThrottlingApi';
import supplyDemandPaceApi from './SupplyDemandPaceApi';
import riderDriverExclusionsApi from './RiderDriverExclusionsApi';
import vehiclesApi from './VehiclesApi';
import driverProfileApi from './DriverProfileApi';
import driverQuestClaimsApi from './DriverQuestClaimsApi';

const allApis = {
  drivers: driversApi,
  search: searchApi,
  users: usersApi,
  trips: tripsApi,
  tags: tagsApi,
  locations: locationsApi,
  fleet: fleetApi,
  promotions: promotionsApi,
  tripThrottling: tripThrottlingApi,
  supplyDemandPace: supplyDemandPaceApi,
  riderDriverExclusions: riderDriverExclusionsApi,
  vehicles: vehiclesApi,
  driverProfile: driverProfileApi,
  driverQuestClaims: driverQuestClaimsApi,
};

export default allApis;
